/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ScanEventsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ScanEventsListFilter>;
}>;


export type ScanEventsQuery = { __typename?: 'Query', scanEvents?: Array<{ __typename?: 'ScanEvent', id: string, createdAt?: any | null, scanEventType?: Types.ScanEventType | null, photos?: Array<{ __typename?: 'ScanEventPhoto', photo?: { __typename?: 'GraphweaverMedia', url: string } | null }> | null, trackableAsset: { __typename?: 'TrackableAsset', id: string, status?: Types.AssetStatus | null, scannableCode?: string | null } } | null> | null };


export const ScanEventsDocument = gql`
    query ScanEvents($filter: ScanEventsListFilter) {
  scanEvents(filter: $filter) {
    id
    createdAt
    scanEventType
    photos {
      photo {
        url
      }
    }
    trackableAsset {
      id
      status
      scannableCode
    }
  }
}
    `;

/**
 * __useScanEventsQuery__
 *
 * To run a query within a React component, call `useScanEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScanEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScanEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useScanEventsQuery(baseOptions?: Apollo.QueryHookOptions<ScanEventsQuery, ScanEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScanEventsQuery, ScanEventsQueryVariables>(ScanEventsDocument, options);
      }
export function useScanEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScanEventsQuery, ScanEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScanEventsQuery, ScanEventsQueryVariables>(ScanEventsDocument, options);
        }
export function useScanEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScanEventsQuery, ScanEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScanEventsQuery, ScanEventsQueryVariables>(ScanEventsDocument, options);
        }
export type ScanEventsQueryHookResult = ReturnType<typeof useScanEventsQuery>;
export type ScanEventsLazyQueryHookResult = ReturnType<typeof useScanEventsLazyQuery>;
export type ScanEventsSuspenseQueryHookResult = ReturnType<typeof useScanEventsSuspenseQuery>;
export type ScanEventsQueryResult = Apollo.QueryResult<ScanEventsQuery, ScanEventsQueryVariables>;